import React from "react";
import PropTypes from "prop-types";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { PageContextUtils, LazyLoadUtils } from "../../utils/index.js";

const RegulationLogosSection = props => {
  const { showControlCenter } = props;
  const brandId = useSelector(UserContextSelectors.brandId);
  const { name } = PageContextUtils.getClientProviderData();
  try {
    const RegulationLogosSectionWrapped = LazyLoadUtils.lazyWithFallback(
      () =>
        import(
          /* webpackChunkName: "[request]" */
          `../Brands/${brandId}/${name}/RegulationLogosSection.layout.js`
        ),
      { componentName: "RegulationLogosSection" }
    );

    return (
      RegulationLogosSectionWrapped && (
        <RegulationLogosSectionWrapped showControlCenter={showControlCenter} />
      )
    );
  } catch {
    return null;
  }
};

RegulationLogosSection.propTypes = {
  showControlCenter: PropTypes.bool
};

export default React.memo(RegulationLogosSection);
